import DialogBoxActionType from "chrome/dialogBox/duck/actionTypes/dialogBoxActionType";
import ICloseDialogBoxAction from "chrome/dialogBox/duck/actions/interfaces/ICloseDialogBoxAction";

const closeDialogBox: () => ICloseDialogBoxAction = (): ICloseDialogBoxAction => ({
    type: DialogBoxActionType.CLOSE_DIALOG_BOX,
});

export default closeDialogBox;
